import type { Segmentation } from '@/shared/types/segmentation';

/** true quando os critérios mudaram depois da última resolução de público
 * (ver Segmentation.criteriaChangedAt/lastResolvedAt) -- UI mostra aviso "desatualizado". */
export function isSegmentationStale(
  segmentation: Pick<Segmentation, 'criteriaChangedAt' | 'lastResolvedAt'>,
): boolean {
  if (!segmentation.criteriaChangedAt) return false;
  if (!segmentation.lastResolvedAt) return true;
  return new Date(segmentation.criteriaChangedAt).getTime() > new Date(segmentation.lastResolvedAt).getTime();
}
